
import { writable } from 'svelte/store'

export const catalog = writable([])

export const api_url = writable("https://di29blipxg.execute-api.us-east-1.amazonaws.com/production/fc2/") // api gateway fc2
// export const api_url = writable("http://localhost:8000") // use for Andy local development
